import { TilemapEditsManager } from "../../GameMap/TilemapEditsManager";
import type { WamFile } from "../../GameMap/WamFile";
import { Command } from "../Command";

export interface UpdateTileLayerConfig {
    name?: string;
    opacity?: number;
    visible?: boolean;
}

export class UpdateTileLayerCommand extends Command {
    protected wamFile: WamFile;

    constructor(
        wamFile: WamFile,
        protected readonly layerId: number,
        protected readonly config: UpdateTileLayerConfig,
        commandId?: string,
    ) {
        super(commandId);
        this.wamFile = wamFile;
    }

    public execute(): Promise<void> {
        const overlay = TilemapEditsManager.getOrCreateOverlay(this.wamFile.getWam());
        overlay.layerEdits.push({ action: "update", layerId: this.layerId, ...this.config });
        return Promise.resolve();
    }
}
